var _excluded = ["title", "metric", "visual", "periodChange", "periodLabel", "periodChangeSentiment", "description", "expanded", "accordion", "onAccordionToggle"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect } from 'react';
import styled from 'styled-components';
import * as IconSet from "../../../icons/index.js";
import getTextStyles from "../../../utils/getTextStyles/getTextStyles.js";
import Card from "../../basic/Card/Card.js";
import Icon from "../../basic/Icon/Icon.js";
import Layout from "../../basic/Layout/Layout.js";
import BodyText from "../../type/BodyText.js";
import { BODY_TEXT_SIZES } from "../../type/constants.js";
import Heading from "../../type/Heading.js";
var BREAKPOINT_SMALL = 768;
var PHONE_ONLY_MEDIA_QUERY = "@media only screen and (max-width: ".concat(BREAKPOINT_SMALL - 1, "px)");
var DataCardBase = styled(Card).withConfig({
  componentId: "CL__sc-jxqpab-0"
})(["display:flex;flex-direction:column;justify-content:space-between;border-radius:var(--border-radius-medium);padding:", ";> *{&:first-child{", "}}"], _ref => {
  var {
    accordion
  } = _ref;
  return accordion ? 'var(--spacing-4) 0 0' : 'var(--spacing-4)';
}, _ref2 => {
  var {
    accordion
  } = _ref2;
  return accordion && "padding: 0 var(--spacing-4);";
});
var TopLayout = styled(Layout).withConfig({
  componentId: "CL__sc-jxqpab-1"
})(["align-items:flex-start;gap:var(--spacing-1);justify-content:space-between;", " ", "{flex-direction:column-reverse;justify-content:flex-start;}"], _ref3 => {
  var {
    expanded
  } = _ref3;
  return "".concat(expanded ? 'margin-bottom: var(--spacing-1);' : '');
}, PHONE_ONLY_MEDIA_QUERY);
var DataTitle = styled(Heading).withConfig({
  componentId: "CL__sc-jxqpab-2"
})(["", ";color:var(--text-color);"], getTextStyles.bodyText(BODY_TEXT_SIZES.SMALL, {
  isBold: true
}));
var DataMetric = styled(BodyText).withConfig({
  componentId: "CL__sc-jxqpab-3"
})(["margin:0;color:var(--text-color);"]);
var ChevronButton = styled.button.withConfig({
  componentId: "CL__sc-jxqpab-4"
})(["cursor:pointer;text-align:center;padding:0;outline:none;background-color:var(--surface-bkg-color);border:2px solid var(--surface-bkg-color);border-bottom-left-radius:var(--border-radius-medium);border-bottom-right-radius:var(--border-radius-medium);color:var(--text-color-dim);transition:background-color var(--hover-transition);& > span{vertical-align:bottom;}&:hover,&:focus-visible{background:var(--dropdown-bkg-hover-color);color:var(--link-color);}&:active{background:var(--dropdown-bkg-active-color);}"]);
var Description = styled(BodyText).withConfig({
  componentId: "CL__sc-jxqpab-5"
})(["height:100%;"]);
var AccordionIcon = styled(Icon).withConfig({
  componentId: "CL__sc-jxqpab-6"
})(["svg{transition:transform var(--hover-transition) var(--transition-easing);}", ""], _ref4 => {
  var {
    expanded
  } = _ref4;
  return "\n    ".concat(expanded && "\n        svg {\n          transform: scaleY(-1);\n          transform-origin: 50% 50%;\n        }\n      ", "\n  ");
});
var changeTextColors = {
  positive: {
    light: 'var(--green-5)',
    dark: 'var(--green-core)'
  },
  negative: {
    light: 'var(--red-6)',
    dark: 'var(--red-core)'
  },
  neutral: {
    light: 'var(--text-color-dim)',
    dark: 'var(--text-color-dim)'
  }
};
var PeriodChangeText = styled.span.withConfig({
  componentId: "CL__sc-jxqpab-7"
})(["font-weight:var(--body-text-bold-font-weight);", ""], _ref5 => {
  var {
    sentiment
  } = _ref5;
  return "\n    color: ".concat(changeTextColors[sentiment].light, ";\n    [data-theme='dark'] && {\n      color: ").concat(changeTextColors[sentiment].dark, ";\n    }\n  ");
});
var PeriodChange = _ref6 => {
  var {
    periodChange = '0%',
    periodChangeSentiment
  } = _ref6;
  var periodChangeNumber = parseFloat(periodChange.replace(/%/g, ''));
  var sentiment = periodChangeSentiment !== null && periodChangeSentiment !== void 0 ? periodChangeSentiment : periodChangeNumber >= 0 ? 'positive' : 'negative';
  return /*#__PURE__*/React.createElement(PeriodChangeText, {
    sentiment: sentiment
  }, periodChangeNumber > 0 && '+', periodChange, ' ');
};
var DataCard = _ref7 => {
  var {
      title,
      metric,
      visual,
      periodChange,
      periodLabel,
      periodChangeSentiment,
      description,
      expanded = false,
      accordion = true,
      onAccordionToggle
    } = _ref7,
    props = _objectWithoutProperties(_ref7, _excluded);
  var [isExpanded, setIsExpanded] = React.useState(expanded);
  var toggleDescription = () => {
    setIsExpanded(!isExpanded);
    onAccordionToggle === null || onAccordionToggle === void 0 || onAccordionToggle(!isExpanded);
  };
  useEffect(() => {
    setIsExpanded(expanded);
  }, [expanded]);
  return /*#__PURE__*/React.createElement(DataCardBase, _extends({
    accordion: accordion
  }, props, {
    "aria-expanded": isExpanded
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TopLayout, {
    expanded: isExpanded
  }, /*#__PURE__*/React.createElement(Layout, {
    gap: "0",
    align: "left",
    valign: "center",
    vertical: true
  }, /*#__PURE__*/React.createElement(DataTitle, {
    "data-testid": "title",
    forwardedAs: "h4",
    size: "x-small"
  }, title), /*#__PURE__*/React.createElement(DataMetric, {
    "data-testid": "metric",
    size: "large"
  }, /*#__PURE__*/React.createElement("strong", null, metric)), (periodChange || periodLabel) && /*#__PURE__*/React.createElement(BodyText, {
    as: "span",
    size: "x-small",
    "data-testid": "period-change"
  }, periodChange && /*#__PURE__*/React.createElement(PeriodChange, {
    periodChange: periodChange,
    periodChangeSentiment: periodChangeSentiment
  }), periodLabel)), visual !== null && visual !== void 0 ? visual : null), isExpanded && /*#__PURE__*/React.createElement(Description, {
    forwardedAs: "span",
    "data-testid": "description",
    size: "small"
  }, description)), accordion && /*#__PURE__*/React.createElement(ChevronButton, {
    "aria-label": isExpanded ? 'Hide description' : 'Expand description',
    onClick: () => toggleDescription()
  }, /*#__PURE__*/React.createElement(AccordionIcon, {
    component: IconSet.ChevronDown,
    size: 24,
    expanded: isExpanded
  })));
};
export default DataCard;